module.exports = __webpack_public_path__ + "media/images/edit-note-7af64f9fb15703055a8fd7be95ab2bea.svg";